"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.ButtonContainer = exports.Container = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const theme_1 = require("../../../theme");
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.ButtonContainer = styled_components_1.default.fieldset `
  display: inline-flex;
  flex-direction: ${(props) => props.direction};
  gap: 0.75rem;
  border: 0;
  padding: 0;
`;
exports.Label = styled_components_1.default.legend `
  font-size: 14px;
  font-weight: 200;
  color: ${theme_1.GREY4};

  label {
    color: currentColor;
    font-size: 14px;
  }

  ${({ $isDisabled }) => $isDisabled &&
    (0, styled_components_1.css) `
      color: ${theme_1.GREY2} !important;
      label {
        color: currentColor !important;
      }
    `}
`;
//# sourceMappingURL=RadioButtons.styles.js.map